export enum FILTER_OPERATOR {
  AND = ',',
  OR = '|',
}

export enum FITLER_SET_OPERATOR {
  AND = 1,
  OR = 2,
}

export const INITIAL_FILTER_SET_QUERY: FilterSetQuery = {
  filterQueryFormats: [],
};

export const filterOperatorDic: Record<FILTER_OPERATOR, string> = {
  [FILTER_OPERATOR.OR]: 'include any of',
  [FILTER_OPERATOR.AND]: 'include all of',
};

export const filterSetOperatorDic: Record<FITLER_SET_OPERATOR, string> = {
  [FITLER_SET_OPERATOR.OR]: 'any filter',
  [FITLER_SET_OPERATOR.AND]: 'all filter',
};

export const filterOperatorConverter = (
  op: FILTER_OPERATOR,
): FITLER_SET_OPERATOR => {
  switch (op) {
    case FILTER_OPERATOR.AND:
      return FITLER_SET_OPERATOR.AND;
    case FILTER_OPERATOR.OR:
      return FITLER_SET_OPERATOR.OR;
    default:
      throw new Error('Invalid filter operator');
  }
};

export const filterSetOperatorConverter = (
  op: FITLER_SET_OPERATOR,
): FILTER_OPERATOR => {
  switch (op) {
    case FITLER_SET_OPERATOR.AND:
      return FILTER_OPERATOR.AND;
    case FITLER_SET_OPERATOR.OR:
      return FILTER_OPERATOR.OR;
    default:
      throw new Error('Invalid filter set operator');
  }
};

type GetOperatorOptions = {
  operator?: FILTER_OPERATOR;
  multiFilter?: boolean;
  isMultiValueField?: boolean;
};

export const getFilterOperatorText = (options?: GetOperatorOptions): string => {
  if (options?.isMultiValueField) {
    if (options?.multiFilter) {
      if (options?.operator) {
        return filterOperatorDic[options?.operator];
      } else {
        throw new Error('When multifilter is true, operator must be given');
      }
    } else {
      return 'include';
    }
  } else {
    if (options?.multiFilter) {
      return 'is any of';
    } else {
      return 'is';
    }
  }
};
